var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modal overflow-auto" },
    [
      _vm.step === 1
        ? _c("supporter-details", {
            on: {
              nextStep: function($event) {
                return _vm.moveToNextStep()
              }
            }
          })
        : _vm._e(),
      _vm.step === 2
        ? _c("donation-details", {
            on: {
              previousStep: function($event) {
                return _vm.moveToPreviousStep()
              },
              nextStep: function($event) {
                return _vm.moveToNextStep()
              },
              moveToStep: _vm.moveToStep
            }
          })
        : _vm._e(),
      _vm.step === 3 && _vm.payload.paymentCaptureSystem === "sms"
        ? _c("donation-payment-sms", {
            on: {
              nextStep: function($event) {
                return _vm.moveToNextStep()
              }
            }
          })
        : _vm._e(),
      _vm.step === 3 && _vm.payload.paymentCaptureSystem === "web"
        ? _c("donation-payment", {
            on: {
              previousStep: function($event) {
                return _vm.moveToPreviousStep()
              },
              nextStep: function($event) {
                return _vm.moveToNextStep()
              }
            }
          })
        : _vm._e(),
      _vm.step === 4 ? _c("donation-receipt") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }